import React from 'react';
import { connect } from 'react-redux';

import { Button, ButtonBase, TextField } from '@mui/material';

import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import ArrowLeftIcon from '@mui/icons-material/ChevronLeft';
import ArrowRightIcon from '@mui/icons-material/ChevronRight';

import Node from '../../../../../common/Node';
import PredicateChain from '../../../../../common/PredicateChain';
import TrplSelect from '../../../../../common/TrplControls/TrplSelect';

import { trplFormEditColumnWidthes, trplFormEditColumnHeights } from '../../../../../constants';
import { getTablesSelectValues, getLastRstData } from '../../../../../utils';

export default connect((state) => ({ jels: state.jels }))(
  ({
    jels,
    group,
    classes,
    rowIndex,
    setupRbox,
    groupIndex,
    deleteGroup,
    groupsLength,
    formConcepts,
    openTableEditModal,
    onGroupTableSelect,
    onGroupFieldChange,
    changeGroupPosition,
    onAccordeonRstChange,
    onGroupSizeSelectChange,
  }) => {

    const tblSelectValue = group.tableId && jels.jelData[group.tableId] ? group.tableId : 'none';
    const tblEditDisabled = tblSelectValue === 'none';

    const groupConceptKey = group && group.concept_key ? group.concept_key : 'concept';
    const conceptId = formConcepts && groupConceptKey && formConcepts[groupConceptKey] ? formConcepts[groupConceptKey] : null;
    const groupRstId = group && group.restrictions ? group.restrictions : [];
    const groupRstData = groupRstId && groupRstId[0] ? getLastRstData(groupRstId[0], formConcepts[groupConceptKey], setupRbox) : null;

    const tblsSelectValues = groupRstData && groupRstData.oid ? getTablesSelectValues(jels, groupRstData.oid) : getTablesSelectValues(jels, conceptId);

    return (
      <div className={classes.container}>
        <div
          className={classes.column}
          style={{
            marginBottom: '10px',
          }}
        >
          <strong style={{ color: '#c4c4c4' }}>Table</strong>
          <div className={`${classes.alignCenter} ${classes.mb10}`}>
            <TextField
              style={{
                width: '100%',
                marginRight: '10px',
              }}
              label="Title"
              placeholder="Title"
              value={group.title}
              className={classes.tableEditInput}
              onChange={(e) => onGroupFieldChange(rowIndex, groupIndex, 'title', e.target.value)}
            />

            <div className={`${classes.alignCenter} ${classes.mb10}`}>
              <div className={classes.mr10}>
                <TrplSelect
                  title="Width"
                  margin="none"
                  complicatedValues
                  values={trplFormEditColumnWidthes}
                  value={group.width || 'auto'}
                  onChange={(e) => {
                    onGroupSizeSelectChange(rowIndex, groupIndex, 'width', e.target.value);
                  }}
                />
              </div>

              <TrplSelect
                title="Height"
                margin="none"
                complicatedValues
                values={trplFormEditColumnHeights}
                value={group.height || 'auto'}
                onChange={(e) => {
                  onGroupSizeSelectChange(rowIndex, groupIndex, 'height', e.target.value);
                }}
              />
            </div>
          </div>

          <div className={classes.mb20}>
            <div className={classes.alignCenter}>
              <TrplSelect
                margin="none"
                complicatedValues
                values={tblsSelectValues}
                value={tblSelectValue}
                firstChilds={
                  <ButtonBase
                    style={{ textTransform: 'none' }}
                    onClick={() => {
                      openTableEditModal(rowIndex, groupIndex, null, groupRstData ? groupRstData.oid : conceptId);
                    }}
                    className={`${classes.btnGray} ${classes.mb5}`}
                  >
                    Create table <AddIcon className={`btn-gray-icon ${classes.btnGrayIcon}`} />
                  </ButtonBase>
                }
                onChange={(e) => {
                  onGroupTableSelect(rowIndex, groupIndex, e.target.value);
                }}
              />

              <ButtonBase
                className={classes.ml10}
                disabled={tblEditDisabled}
                style={{
                  opacity: `${tblEditDisabled ? '0.5' : ''}`,
                }}
                onClick={() => openTableEditModal(rowIndex, groupIndex, true)}
              >
                <EditIcon className={classes.editFrmIcon} />
              </ButtonBase>
            </div>
          </div>

          <div className={classes.alignCenter}>
            <div>
              <span style={{ color: '#878787', fontSize: 11 }}>Concept</span>
              <div className={`${classes.alignCenter} ${classes.mr10}`} style={{ marginBottom: '1px' }}>
                {conceptId ?
                  <div className={classes.mr5}>
                    <Node
                      isLink
                      size="xs"
                      nodes={setupRbox}
                      nodeId={conceptId}
                      node={setupRbox[conceptId]}
                    />
                  </div>
                : null}
                <TrplSelect
                  margin="none"
                  values={Object.keys(formConcepts)}
                  value={groupConceptKey}
                  onChange={(e) => {
                    onGroupFieldChange(rowIndex, groupIndex, 'concept_key', e.target.value, () => {
                      onAccordeonRstChange(rowIndex, groupIndex, null);
                    });
                  }}
                />
              </div>
            </div>
            <div className={classes.fillAvailable}>
              <span style={{ color: '#878787', fontSize: 11 }}>Predicate</span>
              <div style={{ width: '100%' }}>
                <PredicateChain
                  mode="edit"
                  rst={groupRstId}
                  objectTypeOnly={true}
                  maxSelectedRstCount={1}
                  ancestor={formConcepts[groupConceptKey]}
                  addInnerRstCb={({ newSelected }) => {
                    onAccordeonRstChange(rowIndex, groupIndex, newSelected[0]);
                  }}
                  onRemoveRstCb={(props, newSelected) => {
                    onAccordeonRstChange(rowIndex, groupIndex, null);
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        <div className={classes.justifyEnd}>
          {groupIndex !== 0 ? (
            <ArrowLeftIcon
              className={`${classes.mr10} ${classes.pointer}`}
              onClick={() => {
                changeGroupPosition(rowIndex, groupIndex, groupIndex - 1);
              }}
            />
          ) : null}

          {groupIndex !== groupsLength ? (
            <ArrowRightIcon
              className={`${classes.mr10} ${classes.pointer}`}
              onClick={() => {
                changeGroupPosition(rowIndex, groupIndex, groupIndex + 1);
              }}
            />
          ) : null}

          <Button size="small" color="secondary" variant="contained" onClick={() => deleteGroup(rowIndex, groupIndex)}>
            Delete group
          </Button>
        </div>
      </div>
    );
  }
);
